import { StyledIconButton } from './UpdateDataButton.styles';
import { Icon, Tooltip, useTheme } from '../../../../../../base-components';
import { useFormContext } from 'react-hook-form';
import {
    ITableForm,
    TableFormValues,
    getBasicColorsObject,
} from '../../../../../../../common';
import { useAppDispatch } from '../../../../../../base-redux';
import { tablesActions } from '../../../../../../../actions';
import { useTranslation } from 'react-i18next';

const UpdateDataButton = () => {
    const theme = useTheme();
    const dispatch = useAppDispatch();
    const { getValues } = useFormContext<ITableForm>();
    const { t } = useTranslation();
    const baseColors = getBasicColorsObject(theme.palette);

    const tableId = getValues(TableFormValues.tableId);
    const restartTableData = () => {
        dispatch(
            tablesActions.fetchTableDataById({
                tableId,
                formData: getValues(),
                page: 1,
                baseColors,
            })
        );
    };

    return (
        <Tooltip
            title={t('tablesBase.refreshData')}
            placement="top-start"
            followCursor={false}
            arrow
        >
            <StyledIconButton onClick={restartTableData}>
                <Icon
                    size={20}
                    name={'SyncOutlineIcon'}
                    color={theme.palette.grey[600]}
                />
            </StyledIconButton>
        </Tooltip>
    );
};

export default UpdateDataButton;
